<template>
  <div v-if="show" class="tax-back-banner" :class="bannerClass">
    <div class="tax-back-banner__content" :class="{ 'content-fit': status === 'participando' }">
      <base-icon width="24" height="24" :name="iconName" />
      <div class="text-content">
        <p v-html="bannerText"></p>
        <a v-if="status === 'elegivel'" @click="redirectToPage" class="underline-link">
          Veja como participar
        </a>
      </div>
    </div>
    
    <div v-if="status === 'participando'" class="button-group">
      <button type="button" class="action-button primary-color" @click="openShareModal">
        Divulgar lista
      </button>
      <button type="button" class="action-button secondary-color" @click="redirectToPage">
        Saiba mais
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TaxBackCampaign from '@/lib/api/TaxBackCampaign'
import Marketing from '@/lib/api/Marketing'

export default {
  name: 'WalletBannerTaxBack',
  
  data() {
    return {
      show: false,
      status: 'elegivel',
      isPartner: false
    }
  },

  mounted() {
    this.getUserCampaignEligible()
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken'
    }),
    bannerClass() {
      return {
        'elegivel': this.status === 'elegivel',
        'participando': this.status === 'participando', 
        'winner': this.status === 'winner'
      }
    },

    iconName() {
      return this.status === 'winner' ? 'painel/check-circle' : 'painel/wallet'
    },

    bannerText() {
      if (this.isPartner) {
        const texts = {
          elegivel: 'Ao completar R$18.000 em presentes, você ganha um presente extra de R$120,00 do Casar.com na sua carteira.',
          participando: 'Você já está participando! Ao completar R$18.000 em presentes, ganhe um presente extra de R$120,00 do Casar.com na sua carteira.',
          winner: 'Meta atingida! Você ganhou um presente de R$120 do Casar.com: O Mais Completo Site de Casamento Grátis do Brasil ! O valor estará disponível para saque em 20 dias após a data do casamento.'
        }
        return texts[this.status]
      }

      const texts = {
        elegivel: 'Ao completar R$ 6.500 em presentes, ganhe um benefício de R$ 120 na sua carteira.',
        participando: 'Você já está participando! Atinja R$ 6.500 em presentes e ganhe um benefício de R$ 120 na sua carteira.',
        winner: 'Meta atingida! Você ganhou o benefício de R$ 120. O valor estará disponível para saque em 20 dias após a data do casamento.'
      }
      return texts[this.status]
    }
  },

  methods: {
    getUserCampaignEligible() {
      const marketingApi = new Marketing(this.logonToken)
      const taxBackCampaign = new TaxBackCampaign(this.logonToken)

      Promise.all([marketingApi.getMarketingOrigin(), taxBackCampaign.getUserCampaignAdhesion()])
        .then(([marketingOrigin, campaignAdhesion]) => {
          this.isPartner = marketingOrigin.data?.utm_source === 'parceiros'
          this.show = campaignAdhesion.data?.elegivel_campanha == 1 ?? false;

          if(campaignAdhesion.data?.atingiu_campanha == 1) {
            this.status = 'winner'
            return
          }

          this.status = campaignAdhesion.data?.adesao_campanha == 1 ? 'participando' : 'elegivel'
        })
        .catch((error) => console.error(error))
    },

    openShareModal() {
      this.$emit('open-share-modal')
    },

    redirectToPage() {
      this.$router.push('/campanha/taxa-de-volta')
    }
  }
}
</script>

<style lang="scss" scoped>
.tax-back-banner {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 16px 2em 16px 2.5em;
  padding: 12px;
  gap: 8px;
  border-radius: 8px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    margin: 16px 1em;
  }

  &.elegivel,
  &.participando {
    background-color: #FCF3F6;
    &__content {
      width: fit-content;
    }
  }

  &.winner {
    background-color: #F2FBFA;
  }

  &__content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 8px;

    &.content-fit {
      width: fit-content !important;
    }

    svg {
      min-width: 24px;
      min-height: 24px;
      flex-shrink: 0;
    }

    .elegivel &,
    .participando & {
      svg {
        color: #E583A2;
      }
    }

    .winner & {
      svg {
        color: #3DAFB0;
      }
    }

    .text-content {
      display: flex;
      flex-direction: row;
      gap: 4px;

      p {
        font-size: 14px;
        font-weight: 700;
        line-height: 20px;
        margin: 0;
      }

      .underline-link {
        font-size: 14px;
        font-weight: 700;
        text-decoration: underline;
        cursor: pointer;
        width: fit-content;
      }
    }

    .elegivel &,
    .participando & {
      .text-content p,
      .text-content .underline-link {
        color: #E583A2;
      }
    }

    .winner & {
      .text-content p {
        color: #3DAFB0;
      }
    }
  }

  .button-group {
    display: flex;
    gap: 12px;
    align-items: center;

    @media screen and (max-width: 768px) {
      width: 100%;
      flex-direction: column;
    }

    .action-button {
      padding: 8px 16px;
      border-radius: 100px;
      border: none;
      cursor: pointer;
      font-size: 14px;
      font-weight: 700;
      white-space: nowrap;

      &.primary-color {
        background-color: #E583A2;
        color: #fff;
      }

      &.secondary-color {
        background-color: transparent;
        border: 1px solid #7D95AA;
        color: #7D95AA;
      }

      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }
}
</style>
